import type { ReactNode, CSSProperties } from 'react'
import 'enasops/styles/components/title.less'

type Props = {
  className?: string,
  style?: CSSProperties,
  title: ReactNode,
}

const Title = (props: Props) => {
  return (
    <div className={`title ${props.className || ''}`} style={props.style}>
      <div className='title__divide' />
      <span className='title__title'>{props.title}</span>
    </div>
  )
}

export default Title